<template>
  <div class="flex flex-col lg:flex-row gap-6">
    <div class="w-full lg:w-3/12">
      <div class="bg-white p-4 rounded-lg border border-gray-100 shadow-md h-full">
        <div class="mb-4 flex items-center justify-center">
          <h3 class="text-lg font-semibold text-gray-800 text-center">
            {{ t('assets.dashboard.aiReport.title') }} </h3>
          <VTooltip :title="t('common.tooltipInformations.reportAssistant')" information>
            <template #content>
              <icon-component icon="info" iconClass="text-primary hover:bg-gray-100 p-1 rounded-full text-sm"/>
            </template>
          </VTooltip>
        </div>

        <ReportStatus :asset-list="dashboardStore.chart.selectedAssets" :date-picker-model="datePickerModel"/>
      </div>
    </div>

    <div class="w-full lg:w-9/12">
      <div class="bg-white p-4 rounded-lg border border-gray-100 shadow-md">
        <AssetsTable @selection-change="handleAssetSelection" @asset-data="handleAssetData"/>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import dayjs from 'dayjs'
import { useDashboardStore } from '@/stores/dashboardOfAssets'
import AssetsTable from '../AssetsTable.vue'
import ReportStatus from './components/ReportStatus.vue'
import { useI18n } from 'vue-i18n'
import VTooltip from '@/components/common/VTooltip.vue'
import IconComponent from '@/components/common/VIcon.vue'

const props = defineProps({
  chartData: {
    type: Object,
    required: false,
  },
})

const { t } = useI18n()
const emit = defineEmits(['selectionChange', 'asset-data'])
const dashboardStore = useDashboardStore()
const datePickerModel = ref({
  start: dayjs().startOf('year').toDate(),
  end: dayjs().toDate(),
})

const handleAssetSelection = (selectedAssets) => {
  dashboardStore.setSelectedAssets(selectedAssets)
  dashboardStore.resetReportStatus()
  emit('selectionChange', selectedAssets)
}

const handleAssetData = (data) => {
  dashboardStore.setChartData(data)
  emit('asset-data', data)
}
</script>